import React from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { DeviceNameCell } from "../../../../../components/table";
import { multipleDeviceIdSort } from "../../../../../components/table/helpers/sorting.helper";
import { DeviceWithType } from "../../../../../components/devices/DeviceWithType";
import { Manufacturer } from "../../../../../components/manufacturer/Manufacturer";
import { ProfileDevicesDropdownActions, TableCard } from "./components";

export const COLUMNS = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    sortable: true,
    Cell: ({ row: { original } }) => {
      const name = _.unescape(original.name); // why do we have this special use-case here with _unescape, but not in other tables?

      return <DeviceNameCell name={name} />;
    },
  },
  {
    Header: <FormattedMessage id={"device_id_devices_table_header"} />,
    accessor: "identifiers",
    sortable: true,
    sortType: multipleDeviceIdSort,
    Cell: ({
      row: {
        original: { details },
      },
    }) => (
      <div className={"identifiers-block"}>
        {_.map(details, ({ type, identifier }) => (
          <DeviceWithType
            key={identifier}
            type={type}
            identifier={identifier}
          />
        ))}
      </div>
    ),
  },
  {
    Header: <FormattedMessage id={"manufacturer_devices_table_header"} />,
    accessor: "manufacturer",
    sortable: true,
    cellClassName: "color-table__cell",
    Cell: ({
      row: {
        original: { manufacturer },
      },
    }) => <Manufacturer manufacturer={manufacturer} />,
  },
  {
    Header: <FormattedMessage id={"actions"} />,
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { identifiers, details, name, profile },
      },
    }) => (
      <ProfileDevicesDropdownActions
        identifiers={identifiers}
        deviceDetails={details}
        name={name}
        profile={profile}
      />
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "name",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        original: { name, details, identifiers, profile },
      },
    }) => (
      <TableCard
        name={name}
        details={details}
        identifiers={identifiers}
        profile={profile}
      />
    ),
  },
  {
    accessor: "identifiers",
    sortType: multipleDeviceIdSort,
    SortingLabel: <FormattedMessage id={"device_id_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = ["identifiers", "manufacturer", "name"];
